import { PropertyType, PropertyFormat } from '@rappider/rappider-components/utils';
import { AddFieldValue } from 'libs/data-transformation/src/lib/shared';

export const DEFAULT_ADD_FIELD_VALUE_DATA: AddFieldValue = {
  type: PropertyType.String,
  format: null,
  key: null
};
